import React, { memo, useMemo } from 'react';
import {
  PERCUSION_CORPORAL,
  type PercusionBucketRect,
} from '../../lib/percusionCorporal';
import { bubbleInBucket, type RhythmBubble } from '../../lib/game/atrapaRitmoEngine';
import { playPercusionSound } from '../../lib/usePercusionSounds';
import { RhythmFigureIcon } from '../ecoRitmico/RhythmFigureIcon';

interface PercusionCirculosProps {
  bucketRects: PercusionBucketRect[];
  bubbles: RhythmBubble[];
  flashUntil: Record<number, number>;
  flashNow: number;
  onTap: (percusionId: string) => void;
  disabled?: boolean;
}

export const PercusionCirculos = memo(function PercusionCirculos({
  bucketRects,
  bubbles,
  flashUntil,
  flashNow,
  onTap,
  disabled = false,
}: PercusionCirculosProps) {
  const chargingLanes = useMemo(() => {
    const lanes = new Set<number>();
    for (const b of bubbles) {
      if (b.hit || b.missed) continue;
      const rect = bucketRects.find((r) => r.lane === b.lane);
      if (rect && bubbleInBucket(b, rect)) lanes.add(b.lane);
    }
    return lanes;
  }, [bubbles, bucketRects]);

  return (
    <>
      {bucketRects.map((rect) => {
        const item = PERCUSION_CORPORAL.find((p) => p.id === rect.id);
        if (!item) return null;

        const feedUntil = flashUntil[rect.lane] ?? 0;
        const feeding = feedUntil > flashNow;
        const charging = !feeding && chargingLanes.has(rect.lane);
        const size = rect.r * 2;

        return (
          <button
            key={rect.id}
            type="button"
            disabled={disabled}
            onPointerDown={(e) => {
              e.preventDefault();
              playPercusionSound(item.soundPath);
              onTap(rect.id);
            }}
            className={`ar-percusion-pad absolute flex flex-col items-center justify-center gap-0.5 ${
              feeding ? 'ar-percusion-pad--feed' : charging ? 'ar-percusion-pad--charge' : ''
            }`}
            style={{
              left: rect.screenLeft,
              top: rect.screenTop,
              width: size,
              height: size,
              background: item.bg,
              color: item.color,
            }}
            aria-label={item.label}
          >
            <RhythmFigureIcon figureId={item.figureId} size={size * 0.55} color={item.color} />
            <span className="ar-percusion-pad-label">{item.label}</span>
          </button>
        );
      })}
    </>
  );
});

export default PercusionCirculos;
